import { restClient } from "../raftApi";

export default class ElasticsearchAuthManager {
  /**
   * Class constructor.
   *
   * @param {String} token - String representing an Elasticsearch auth token.
   */
  constructor(token) {
    this.authToken = "";
    if (typeof token !== "undefined") {
      this.authToken = token;
    }
  }

  /**
   * Get an updated auth token.
   *
   * @return {String|null} - Returns a string representing an auth token, or null.
   */
  async getUpdatedToken() {
    const options = {
      path: "/chemical-search/token",
      queries: {},
    };
    const token = await restClient
      .get(options)
      .catch((error) => Promise.reject(error));
    this.setAuthToken(token);
    return token;
  }

  /**
   * Get the Elasticsearch auth token.
   *
   * @return {string|String|*} - Returns a string representing an Elasticsearch auth token.
   */
  getAuthToken() {
    return this.authToken;
  }

  /**
   * Set the auth token string.
   *
   * @param {String} token - String representing an auth token.
   *
   * @return {ElasticsearchAuthManager} - Provides a fluent interface.
   */
  setAuthToken(token) {
    this.authToken = token;
    return this;
  }
}

export { ElasticsearchAuthManager };
